import { readAgentBrand, type AgentBrand } from "./brand.js";

export interface AgentBootstrap {
  signInUrl: string;
  appsUrl: string;
  preferencesUrl: string;
  /** Building from your own AI, which every plan includes; absent in older documents. */
  connectUrl?: string;
  /** Plan & billing, for plans that leave the hosted Agent out; absent in older documents. */
  billingUrl?: string;
  signOutUrl: string;
  logoUrl: string;
  platformAiEnabled: boolean;
  /**
   * People connect their own AI accounts. False on organisation installations,
   * where only organisation admins connect accounts; absent in older documents.
   */
  personalAiAccounts?: boolean;
  /** Installation brand; absent in older documents and synthetic fixtures. */
  brand?: AgentBrand;
}

export function readBootstrap(root: HTMLElement): AgentBootstrap {
  const {
    signInUrl,
    appsUrl,
    preferencesUrl,
    connectUrl,
    billingUrl,
    signOutUrl,
    logoUrl,
    platformAiEnabled,
    personalAiAccounts,
  } = root.dataset;
  if (
    !signInUrl ||
    !appsUrl ||
    !preferencesUrl ||
    !signOutUrl ||
    !logoUrl ||
    !["true", "false"].includes(platformAiEnabled ?? "")
  ) {
    throw new Error("Agent application bootstrap is incomplete");
  }
  return {
    signInUrl,
    appsUrl,
    preferencesUrl,
    connectUrl: connectUrl || new URL("/connect", appsUrl).toString(),
    billingUrl: billingUrl || new URL("/billing", appsUrl).toString(),
    signOutUrl,
    logoUrl,
    platformAiEnabled: platformAiEnabled === "true",
    personalAiAccounts: personalAiAccounts !== "false",
    brand: readAgentBrand(root.dataset),
  };
}

/** Whether people connect their own AI accounts; older documents always allowed it. */
export function personalAiAccountsAllowed(bootstrap: Pick<AgentBootstrap, "personalAiAccounts">): boolean {
  return bootstrap.personalAiAccounts !== false;
}
